/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, withStyles, MenuItem, FormLabel, IconButton, ClickAwayListener } from '@material-ui/core';
import Styles from '../../layouts/Styles.jsx';
import classNames from 'classnames';
import Search from '../TextBox/Search.jsx';
import NotificationStyles from './NotificationStyles.jsx';
import ToolTipComponent from '../Tooltip/Tooltip.jsx';
import TextBox from '../TextBox/TextBox.jsx';
import { sortTable } from '../../helpers/appHelpers.jsx'

const NotificationFilter = (props) => {
    const { classes, theme, onChangeFilterResult, notifications, notificationFilters } = props;
    const controllerRef = useRef();
    const [enableFilter, setFilter] = useState(false);
    const [typeFilters, setTypeFilters] = useState([{ name: "All", value: "All" }]);

    useEffect(() => {
        if (notifications) {
            const notificaitonTypes = [{ name: "All", value: "All" }]
            notifications.forEach((noti) => {
                if (!notificaitonTypes.some(elem => elem.value === noti?.notification_type)) {
                    notificaitonTypes.push({ name: noti?.notification_type, value: noti?.notification_type });
                }
            })
            setTypeFilters(notificaitonTypes)
        }
    }, [notifications])

    const getNotificationList = useCallback((filters) => {
        if (controllerRef.current) {
            controllerRef.current.abort();
        }
        const controller = new AbortController();
        controllerRef.current = controller;
        const signal = controllerRef.current?.signal;
        onChangeFilterResult(filters, signal);
    }, [onChangeFilterResult]);

    const onChangeFilter = useCallback((property, value) => {
        notificationFilters[property] = value
        getNotificationList({ ...notificationFilters });
    }, []);

    const resetFilter = useCallback(() => {
        const filter = {
            types: "All",
            filter: "Last 3 Days",
            notification: "All",
            search: ""
        };
        const filters = {
            ...filter
        };
        getNotificationList({ ...filters });
    }, []);

    const enableFilterInfo = () => {
        setFilter(true);
    };

    return (
        <Grid container alignItems="center" justify="space-between" className={classNames(classes.headerContainer, classes.catHeaderContainer)}>
            <Grid item>
                <Typography variant="h2" component="h2">
                    Notification
                </Typography>
            </Grid>
            <Grid item>
                <Grid container alignItems="center">
                    <Grid style={{ marginRight: 7 }}>
                        <Search
                            value={notificationFilters.search ? notificationFilters.search : ""}
                            placeholder="Search Here"
                            className={classes.dqSearchBox}
                            onChange={(value) => onChangeFilter('search', value)}
                        />
                    </Grid>
                    {
                        enableFilter &&
                        <Grid className={classNames(classes.filterContainer)}>
                            <ClickAwayListener onClickAway={() => setFilter(false)} mouseEvent={'onMouseUp'} touchEvent={'onTouchEnd'}>
                                <Grid container alignItems="center" justify="space-between" className={classNames(classes.datasourceFilterSection, "datasourceFilterSection")}>
                                    <ToolTipComponent title="Close" placement="bottom" arrow>
                                        <IconButton onClick={() => setFilter(!enableFilter)} className={classes.marginRight12}>
                                            <svg id="close-24px_4_" data-name="close-24px (4)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path id="Path_1435" data-name="Path 1435" d="M0,0H24V24H0Z" fill="none" />
                                                <path id="Path_1436" data-name="Path 1436" d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z" fill="#afb2b3" />
                                            </svg>
                                        </IconButton>
                                    </ToolTipComponent>
                                    <Grid item className={classNames(classes.marginRight25, classes.select, classes.filterselect)}>
                                        <FormLabel>
                                            Notification
                                        </FormLabel>
                                        <TextBox
                                            value={notificationFilters.notification}
                                            name="notification"
                                            fullWidth
                                            select
                                            onChange={(event) => onChangeFilter(event.target.name, event.target.value)}
                                            SelectProps={
                                                {
                                                    className: classes.cursorPointer,
                                                    value: notificationFilters.notification,
                                                    onChange: (event) => onChangeFilter(event.target.name, event.target.value),
                                                    MenuProps: {
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "center"
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "center"
                                                        },
                                                        getContentAnchorEl: null
                                                    }
                                                    // IconComponent: () => DropDownIcon()
                                                }
                                            }
                                        >
                                            {
                                                sortTable(["All", "Client", "Package", "License"], "asc", "name").map((status, index) =>
                                                    <MenuItem key={index} value={status}>
                                                        {status}
                                                    </MenuItem>
                                                )
                                            }
                                        </TextBox>
                                    </Grid>
                                    <Grid item className={classNames(classes.marginRight25, classes.select, classes.filterselect)}>
                                        <FormLabel>
                                            Type
                                        </FormLabel>
                                        <TextBox
                                            value={notificationFilters.types}
                                            name="types"
                                            fullWidth
                                            select
                                            onChange={(event) => onChangeFilter(event.target.name, event.target.value)}
                                            SelectProps={
                                                {
                                                    className: classes.cursorPointer,
                                                    value: notificationFilters.types,
                                                    onChange: (event) => onChangeFilter(event.target.name, event.target.value),
                                                    MenuProps: {
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "center"
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "center"
                                                        },
                                                        getContentAnchorEl: null
                                                    }
                                                    // IconComponent: () => DropDownIcon()
                                                }
                                            }
                                        >
                                            {
                                                sortTable(typeFilters, "asc", "name").map((filter, index) =>
                                                    <MenuItem key={index} value={filter.value}>
                                                        {filter.name}
                                                    </MenuItem>
                                                )
                                            }
                                        </TextBox>
                                    </Grid>
                                    <Grid item className={classNames(classes.marginRight25, classes.select, classes.filterselect)}>
                                        <TextBox
                                            label="Filter By"
                                            value={notificationFilters.filter}
                                            name="filter"
                                            fullWidth
                                            select
                                            onChange={(event) => onChangeFilter(event.target.name, event.target.value)}
                                            SelectProps={
                                                {
                                                    className: classes.cursorPointer,
                                                    value: notificationFilters.filter,
                                                    onChange: (event) => onChangeFilter(event.target.name, event.target.value),
                                                    MenuProps: {
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "center"
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "center"
                                                        },
                                                        getContentAnchorEl: null
                                                    }
                                                    // IconComponent: () => DropDownIcon()
                                                }
                                            }
                                        >
                                            {
                                                ["All", "Last 3 Days", "Last 7 Days", "Last 30 Days", "Last 60 Days", "Last 90 Days", "Today"].map((status, index) =>
                                                    <MenuItem key={index} value={status}>
                                                        {status}
                                                    </MenuItem>
                                                )
                                            }
                                        </TextBox>
                                    </Grid>
                                    <Grid item>
                                        <ToolTipComponent title="Clear Filter" placement="bottom" arrow>
                                            <IconButton onClick={() => resetFilter()}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22.795" viewBox="0 0 20 22.795">
                                                    <g id="filter_10_" data-name="filter (10)" transform="translate(-31.388)">
                                                        <path id="Path_1437" data-name="Path 1437" d="M46.071,0a5.326,5.326,0,0,0-5.1,3.8h-8.59a1,1,0,0,0-.814,1.564l5.776,7.882a1.046,1.046,0,0,1,.185.6V21.75a1.044,1.044,0,0,0,1.668.835l2.564-1.937a1.527,1.527,0,0,0,.612-1.22V13.84a1.047,1.047,0,0,1,.185-.6l2.07-2.825A5.31,5.31,0,1,0,46.071,0ZM41.477,12.462a2.375,2.375,0,0,0-.438,1.377c0,6.076.033,5.658-.075,5.737l-2.1,1.586V13.84a2.376,2.376,0,0,0-.428-1.364l-5.38-7.341h7.7A5.307,5.307,0,0,0,43.369,9.88Zm4.594-3.18a3.973,3.973,0,1,1,3.982-3.973A3.982,3.982,0,0,1,46.071,9.282Z" transform="translate(0)" fill="#f38080" />
                                                        <path id="Path_1438" data-name="Path 1438" d="M321.45,76.089a.668.668,0,0,0-.944,0l-.793.791-.793-.791a.668.668,0,0,0-.944.945l.791.79-.791.79a.668.668,0,0,0,.944.945l.793-.791.793.791a.668.668,0,0,0,.944-.945l-.791-.79.791-.79A.668.668,0,0,0,321.45,76.089Z" transform="translate(-273.642 -72.515)" fill="#f38080" />
                                                    </g>
                                                </svg>
                                            </IconButton>
                                        </ToolTipComponent>
                                    </Grid>
                                </Grid>
                            </ClickAwayListener>
                        </Grid>
                    }
                    <ToolTipComponent title="Filters" placement="bottom" arrow>
                        <IconButton onClick={() => enableFilterInfo()} className={classNames(classes.marginRight7, classes.filterImg)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16.923" viewBox="0 0 20 16.923">
                                <g transform="translate(-3 -5)">
                                    <path id="Path_1391" data-name="Path 1391" d="M22.231,6.538H11.462A1.54,1.54,0,0,0,9.923,5H8.385A1.54,1.54,0,0,0,6.846,6.538H3.769a.769.769,0,1,0,0,1.538H6.846A1.54,1.54,0,0,0,8.385,9.615H9.923a1.54,1.54,0,0,0,1.538-1.538H22.231a.769.769,0,1,0,0-1.538ZM8.385,8.077V6.538H9.923V7.3s0,0,0,0,0,0,0,0v.766Z" fill={theme.palette.primary.main} />
                                    <path id="Path_1392" data-name="Path 1392" d="M22.231,14.538H17.615A1.54,1.54,0,0,0,16.077,13H14.538A1.54,1.54,0,0,0,13,14.538H3.769a.769.769,0,0,0,0,1.538H13a1.54,1.54,0,0,0,1.538,1.538h1.538a1.54,1.54,0,0,0,1.538-1.538h4.615a.769.769,0,1,0,0-1.538Zm-7.692,1.538V14.538h1.538V15.3s0,0,0,0,0,0,0,0v.766Z" transform="translate(0 -1.846)" fill={theme.palette.primary.main} />
                                    <path id="Path_1393" data-name="Path 1393" d="M22.231,22.538H11.462A1.54,1.54,0,0,0,9.923,21H8.385a1.54,1.54,0,0,0-1.538,1.538H3.769a.769.769,0,0,0,0,1.538H6.846a1.54,1.54,0,0,0,1.538,1.538H9.923a1.54,1.54,0,0,0,1.538-1.538H22.231a.769.769,0,1,0,0-1.538ZM8.385,24.077V22.538H9.923V23.3s0,0,0,0,0,0,0,0v.766Z" transform="translate(0 -3.692)" fill={theme.palette.primary.main} />
                                </g>
                            </svg>
                        </IconButton>
                    </ToolTipComponent>
                </Grid>
            </Grid>
        </Grid>
    );
};

NotificationFilter.propTypes = {
    classes: PropTypes.object,
    theme: PropTypes.object,
    onChangeFilterResult: PropTypes.func,
    history: PropTypes.object,
    notifications: PropTypes.object,
    notificationFilters: PropTypes.object,
};

export default withStyles((theme) => ({
    ...NotificationStyles(theme),
    ...Styles(theme)
}), { withTheme: true })(NotificationFilter);